import styles from "./styles.module.scss";
import React, { useEffect } from "react";
import useCollapse from "react-collapsed";
import { Link } from "react-router-dom";

function Collapsible() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>Développement mobile : Android</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    Android est le système d’exploitation pour mobiles et tablettes et représente environ 60 % de part de marché en France.
                    <br />
                    <br />
                    <b>OrgaExpert</b> a une équipe de développeurs mobile capable de prendre en charge et développer
                    vos idées et projets de la conception à la publication tout en garantissant la bonne qualité du produit.
                </div>
            </div>
        </div>
    );
}
function Collapsible2() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>Développement web : IOS</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    iOS est le système d’exploitation mobile qui domine le marché mondial. Il posséde environ 35,84 % de parts de marché local français.
                    <br />
                    <br />
                     <b>OrgaExpert</b> a une équipe de développeurs mobile capable de prendre en charge et développer vos idées et projets de la conception à
                    la publication tout en garantissant la bonne qualité du produit.
                </div>
            </div>
        </div>
    );
}

function Intro() {
    useEffect(() => {
        window.scrollTo(0, 1000)
    }, [])

    return (
        <>
            <section className={styles.container}>
                <div className={styles.title}>
                    <text>Développement Mobile</text>
                    <p>pour la réussite de vos projets</p>
                </div>
                <div className={styles.bigbox}>

                    <div className={styles.service}>
                        <div className={styles.bigText}>Développement Mobile</div>
                        <div className={styles.paragraph}>
                            Le développement Mobile est actuellement en pleine croissance grâce aux succès de produits tels que l’iOS, l’android ou encore le Windows Phone.<br /><br />
                            Cette tendance offre aux entreprises de nouvelles opportunités pour créer de services innovants ou élargir ces supports de communication, etc.<br /><br />
                            Ayant très vite compris l’intêret de cette technologie, Smartouch en est devenu un spécialiste,  cette expertise nous permettra de réaliser tous vos projets d’applications sur ces nouvelles plates-formes<br /><br/>

                            <b>OrgaExpert</b> vous accompagne sur toutes les phases de vos projets mobiles grâce à une équipe composée d’un ensemble d’experts confirmés dans le développement mobile<br /><br />
                            Notre méthodologie se compose des 5 étapes suivantes :<br/><br />

                            <p>Étude des caractéristiques et des besoins de la cible</p>
                            <p>Développement de l’application Mobile</p>
                            <p>Test en ligne des fonctionnalités de l’application Mobile</p>
                            <p> Mise en ligne et enregistrement de l’application</p>
                            <p> Maintenance et optimisation continue</p>
                        </div>
                    </div>


                    <div className={styles.expandable}>
                        <Collapsible />
                        <Collapsible2 />
                    </div>

                </div>
                <div className={styles.title}>
                    <div className={styles.text2}>Autre services</div>
                </div>
                <div className={styles.bigbox2}>
                    <Link to="/services/developpementWeb">
                    <div className={styles.service1}>
                        <div className={styles.bigText}>Développement Web</div>
                        <img src="/icons/desktop.png" alt="web dev" />
                    </div>
                    </Link>
                    <Link to="/services/e_commerce">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>E-COMMERCE ET MARKETPLACES</div>
                            <img src="/icons/e-commerce.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/transformation_digital">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>CONSEIL ET STRATÉGIE</div>
                            <img src="/icons/assist.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/erp">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>INTÉGRATION ERP</div>
                            <img src="/icons/integration.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/seo">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>SEO ET OPTIMISATION</div>
                            <img src="/icons/seo.png" alt="web dev" />
                        </div>
                    </Link>
                </div>
            </section>
        </>
    )
}

export default Intro;